module.exports = __webpack_public_path__ + "img/poster_video.7a6492fa.jpg";